module.exports = __webpack_public_path__ + "img/ai_help01_img_05.b9bbc333.png";